import { safeAspects } from '@/utils/chartFormat';

const COUNTED_PLANETS = [
  'Sun', 'Moon', 'Mercury', 'Venus', 'Mars',
  'Jupiter', 'Saturn', 'Uranus', 'Neptune', 'Pluto',
];

const PERSONAL_PLANETS = new Set(['Sun', 'Moon', 'Mercury', 'Venus', 'Mars']);

export const SIGN_ELEMENTS = {
  Aries: 'fire',
  Leo: 'fire',
  Sagittarius: 'fire',
  Taurus: 'earth',
  Virgo: 'earth',
  Capricorn: 'earth',
  Gemini: 'air',
  Libra: 'air',
  Aquarius: 'air',
  Cancer: 'water',
  Scorpio: 'water',
  Pisces: 'water',
};

export function getPlanets(chartData) {
  return Array.isArray(chartData?.planets) ? chartData.planets : [];
}

export function getAngles(chartData) {
  return Array.isArray(chartData?.angles) ? chartData.angles : [];
}

export function getAspects(chartData) {
  return safeAspects(chartData?.aspects);
}

export function findPlanet(chartData, name) {
  return getPlanets(chartData).find((planet) => planet.name === name) ?? null;
}

export function findAngle(chartData, name) {
  return getAngles(chartData).find((angle) => angle.name === name) ?? null;
}

export function getCountedPlanets(chartData) {
  return getPlanets(chartData).filter((planet) => (
    COUNTED_PLANETS.includes(planet.name) && planet.sign
  ));
}

export function isPersonalPlanet(name) {
  return PERSONAL_PLANETS.has(name);
}

export function signElement(sign) {
  return SIGN_ELEMENTS[sign] ?? null;
}

export function aspectOrbDegrees(aspect) {
  if (!aspect || typeof aspect !== 'object') {
    return null;
  }
  if (aspect.orb != null && aspect.orb !== '' && !Number.isNaN(Number(aspect.orb))) {
    return Math.abs(Number(aspect.orb));
  }
  const degrees = Number(aspect.orb_degrees ?? 0);
  const minutes = Number(aspect.orb_minutes ?? 0);
  if (Number.isNaN(degrees) || Number.isNaN(minutes)) {
    return null;
  }
  return degrees + minutes / 60;
}

export function isMajorAspectName(aspectName) {
  if (!aspectName || typeof aspectName !== 'string') {
    return false;
  }
  const normalized = aspectName.trim().toLowerCase();
  return ['conjunction', 'opposition', 'square', 'trine', 'sextile'].includes(normalized);
}
